import styled from 'styled-components';

export const ContainerBody = styled.div`
  padding: var(--spacement-medium);
  > p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 143%;
    display: flex;
    align-items: center;
    letter-spacing: 0.018em;
    color: #5a5d68;

    > span {
      font-weight: bold;
      margin-left: 5px;
    }
  }
`;
